export class FileUploadUtil
{
    // getUploadedFileContent: Metodo assincrono para retornar o conteudo em base64string de cada um dos arquivos 
    // informados no componente FileUpload. Exemplo de uso desta funcao:
    // await FileUploadUtil.getUploadedFileContent({ files: event.target }).then((res) => {
    //     var file = res[0]; // exemplo obtendo apenas o 1o arquivo. Para mais arquivos, utilizar res.map()...
    // });
    static getUploadedFileContent = async (data: any): Promise<any[]> => {
        if (!data || !data.files || !data.files.length)
          return new Promise((resolve) => { resolve([]); });

          // Para ler o conteudo do arquivo, o metodo readAsDataURL eh assincrono, portanto
        // criar um Promise por arquivo, para que ao processar todos, o metodo possa retornar um array com cada arquivo:
        const filePromises = data.files.map((file: any) => {
          // Return a promise per file
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async () => {
              try {
                resolve({
                    content: reader.result,
                    name: file.name,
                    mimetype: file.type
                });
              } catch (err) {
                reject(err);
              }
            };
            reader.onerror = (error) => {
              reject(error);
            };

            reader.readAsDataURL(file);
          });
        });
      
        // Wait for all promises to be resolved
        const fileInfos = await Promise.all(filePromises);

        return fileInfos;
      }; 
      
}